import React, { useContext, Fragment } from 'react';
import { Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { I18nContext } from 'translations';

const STEPS = [
  { key: 'pickup', label: 'app.deliveryRoute.action.pickup' },
  { key: 'dropoff', label: 'app.deliveryRoute.action.dropoff' },
  { key: 'return', label: 'app.deliveryRoute.action.return' },
];

export default function PackageProgress({ progress }) {
  const { translate } = useContext(I18nContext);
  if (!progress) return null;

  const steps = STEPS.filter((step) => progress[step.key]);
  if (steps.length === 0) return null;

  return (
    <div
      data-testid="package-progress"
      style={{ display: 'flex', alignItems: 'flex-start', margin: '12px 0' }}
    >
      {steps.map((step, index) => {
        const done = !!progress[step.key]?.completed_at;
        const color = done ? '#93ca00' : '#D5D0DA';
        return (
          <Fragment key={step.key}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: done ? color : '#fff',
                  border: `2px solid ${color}`,
                }}
              >
                {done && <CheckIcon style={{ fontSize: 13, color: '#fff' }} />}
              </div>
              <Typography variant="caption" style={{ marginTop: 4, color, fontWeight: 700, whiteSpace: 'nowrap' }}>
                {translate(step.label)}
              </Typography>
            </div>
            {index < steps.length - 1 && (
              <div style={{ flex: 1, height: 2, backgroundColor: color, margin: '9px 6px 0' }} />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
